<template>
  <div class="wrapper-shared-samples">
    <div class="above-table">
      
        <p>Muestras compartidas</p>
        <Searcher
          placeholder="Buscar por referencia, empleado, cliente o tipo..."
          v-model:search="query"
        />
    
      <a :href="route" class="wrapper-button">
        <StandardButton :buttonLabel="'Exportar a Excel'" />
      </a>
    </div>

    <table>
      <thead>
        <tr>
          <th>Referencia</th>
          <th>Descripción</th>
          <th>Código empleado</th>
          <th>Usuario empleado</th>
          <th>Código cliente</th>
          <th>Fecha</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(sharedSample, index) in filterSharedInfo" :key="index">
          <td>{{ sharedSample.idReference }}</td>
          <td>{{ sharedSample.description }}</td>
          <td>{{ sharedSample.emplid }}</td>
          <td>{{ sharedSample.name }}</td>
          <td>{{ sharedSample.clientCode }}</td>
          <td>{{ sharedSample.sharedTime }}</td>
          <td>{{ sharedSample.type }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { sharedSamplesUse } from "./use/sharedSamplesUse";
import Searcher from "@/components/commons/controls/Searcher.vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";

export default defineComponent({
  name: "SharedSamplesViewView",
  components: {
    Searcher,
    StandardButton,
  },

  setup() {
    const { filterSharedInfo, query, route } = sharedSamplesUse();

    return {
      filterSharedInfo,
      query,
      route,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/sharedSamples/styles/sharedSamplesStyle";
</style>
